var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100 flexCenter"},[_c('div',{staticClass:"dsMainBox"},[_c('div',{staticClass:"w100 ds-detail-top"},[_c('Crumbs')],1),_vm._v(" "),_c('div',[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }